const IST = "Asia/Kolkata"
import imgImage1 from "../assets/not_found.png";

export const NotFoundImage = imgImage1;

export function formatTimeIST(utcTime: string) {
  return new Date(utcTime).toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: IST,
  })
}

export function formatDateIST(utcDate: string) {
  return new Date(utcDate).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: IST,
  })
}
